import React from 'react';
import { motion } from 'framer-motion';
import { FiCode, FiServer, FiCloud, FiLayout, FiMessageSquare, FiTool } from 'react-icons/fi';
import { services } from '../data/portfolioData';

const getServiceIcon = (iconName) => {
  const icons = {
    code: FiCode,
    api: FiServer,
    cloud: FiCloud,
    application: FiLayout,
    consulting: FiMessageSquare,
    support: FiTool,
  };
  const Icon = icons[iconName] || FiCode;
  return <Icon />;
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4 },
  },
};

const Services = () => {
  return (
    <section id="services" className="services">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
      >
        <motion.h2 className="section-comment" variants={itemVariants}>
          {'// services'}
        </motion.h2>
        <motion.p className="section-subtitle" variants={itemVariants}>
          What I can build for you
        </motion.p>

        <motion.div className="services-grid" variants={containerVariants}>
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              variants={cardVariants}
              whileHover={{ y: -8, boxShadow: '0 8px 30px rgba(97, 218, 251, 0.15)' }}
              transition={{ type: 'spring', stiffness: 300 }}
            >
              <div className="service-icon">
                {getServiceIcon(service.icon)}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <span className="service-link">Learn more →</span>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Services;
